"use client";

import { ReactNode } from "react";

type DropCapProps = {
  children: ReactNode;
  className?: string;
};

export function DropCap({ children, className }: DropCapProps) {
  return <p className={`drop-cap text-offwhite/85 ${className ?? ""}`}>{children}</p>;
}
